import { useQuery } from "@tanstack/react-query"

import { getMe } from "@/features/auth/api/me.api"
import { useAuth } from "@/features/auth/hooks/use-auth"

export const meKeys = {
  all: ["me"] as const,
  current: () => [...meKeys.all, "current"] as const,
}

export function useMe() {
  const { isAuthenticated } = useAuth()
  return useQuery({
    queryKey: meKeys.current(),
    queryFn: getMe,
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
  })
}
